<template>
    <div>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/ Question Type Selection </span>
        </v-row>
        <br />
        <center class="heading">
            <h3>Question Type Selection</h3>
        </center>
        <v-card>
            <!-- <v-col cols="12" sm="12" md="12"> -->
            <v-row>
                <v-row class="justify-center pt-2" v-for="link in questiontype" :key="link.id">
                    <br>
                    <!-- <router-link :to="{ name: link.link}" class="link"> -->
                    <router-link to="/papersetter/add-question-to-bank-import" class="link">

                            <!-- <v-list-item >
                                <v-list-item-content>
                                    <v-list-item-title v-model="selectedquestype" @click="calling(link.id)"> -->
                                        <v-btn v-model="selectedquestype" @click="calling(link.id)" x-large :loading="loader" color="#cbe6f0" :class="[currentPage.includes(link.link)?activeClass:'inactive']">
                                        <!-- <center> -->
                                            <strong><h2>{{ link.name }}</h2></strong>
                                        <!-- </center> -->
                                         </v-btn>
                                    <!-- </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item> -->
                            <!-- <span>{{ link.name }}</span> -->
                    </router-link>
                </v-row>
            </v-row><br>
            <!-- </v-col> -->
        </v-card>
        <br />
        <router-view />
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            questiontype: null,
            selectedquestype: "",
            loader: false,
            link_data: [
                {
                    link: "papersetter-add-question-to-bank",
                    icon: "mdi-copyright",
                    name: "MCQ",
                },
                {
                    link: "coe-define-template",
                    icon: "mdi-cogs",
                    name: "OMR",
                },
                {
                    link: "coe-offer-template",
                    icon: "mdi-offer",
                    name: "MultiWord",
                },
            ],
            activeClass: "active",
        }),
        computed: {
            currentPage() {
                return this.$route.path;
            },
        },
        methods: {
            calling(item) {
                (this.selectedquestype = item), this.$store.commit("setquestype", this.selectedquestype);
            },
        },
        mounted() {
            // this.$router.push({ name: 'add-question-Bank'})
            const data = {
                crs_id: this.$store.getters.courseid,
                qtypeid: this.$store.getters.qbankquestype,
                questypeid: this.$store.getters.questype,
                mess: "test",
            };
            this.loader = true;
            axios
                .post("/Qbank/findQuestionType", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.questiontype = res.data.question_type;
                    } else {
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => {
                    this.loader = false;
                });
        },
    };
</script>
<style scoped>
    .link {
        text-decoration: none;
    }
    .router-link-active {
        background: red;
    }
    .active {
        background: none;
    }
    .inactive {
        background: #cbe6f0;
        color: hsla(190, 99%, 30%, 1);
        border: 3px solid hsl(190deg 99% 30% / 64%) !important;
        border-radius: 50px;
        box-shadow: 8px 8px 8px gray;
        width: 150%;
    }
</style>
